import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function InvertedChevronIcon({
  className,
  color,
  size,
  style,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ')}
      color={color}
      fontSize={size}
      style={style}
      viewBox='0 0 20 11'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 9.73606L0.853702 0.153459C0.658522 -0.0510314 0.34194 -0.0511708 0.146595 0.153148C-0.0487489 0.357466 -0.0488821 0.688872 0.146298 0.893362L9.6463 10.8465C9.84159 11.0512 10.1584 11.0512 10.3537 10.8465L19.8537 0.893362C20.0489 0.688872 20.0487 0.357466 19.8534 0.153148C19.6581 -0.0511708 19.3415 -0.0510314 19.1463 0.153459L10 9.73606Z'
      />
    </svg>
  );
}
